export default __webpack_public_path__ + "static/media/LogoDentsuHeartcare.814f0ef3.png";